import React from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import styles from './PagesListHeader.module.css';

import Container from '../../../../blocks/Container';
import Image from '../../../../elements/Image';
import Title from '../../../../elements/Title';
import Text from '../../../../elements/Text';

const PagesListHeader = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/pages-list.md/" } }) {
        edges {
          node {
            frontmatter {
              title
              subtitle
            }
          }
        }
      }
    }
  `);

  const { title, subtitle } = data.allMarkdownRemark.edges[0].node.frontmatter;

  return (
    <div className={styles.learnPagesHeader}>
      <Container>
        <Container type="mobile">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-12 pl-xl-1 pl-lg-1 pr-xl-0 pr-lg-0">
              <Title className={`${styles.learnPagesHeader__title} white-text text-left`}>{title}</Title>
              <Text className="white-text">{subtitle}</Text>
            </div>
            <div className="col-xl-6 col-lg-6 col-12 relative-position d-flex justify-content-xl-end justify-content-lg-end justify-content-center">
              <Image name="man_with_pc" className={styles.learnPagesHeader__image} />
            </div>
          </div>
        </Container>
      </Container>
    </div>
  )
};

export default PagesListHeader;